<div class="border-0 px-4 py-1">
  <div class="row mt-3">
    <div v-for="card in status_cards" :key="card.title" class="col-md-4 mb-3">
      <div class="card text-white border-0 shadow rounded-5 overview-card-bg responsive-card h-100">
  <div class="card-body d-flex align-items-center gap-3 py-3 px-3">
    <!-- Icon -->
    <div class="circular-icon d-flex align-items-center justify-content-center flex-shrink-0 responsive-icon">
      <i :class="[card.icon, 'fa-lg', 'text-primary-blue']"></i>
    </div>

    <!-- Text -->
    <div class="d-flex flex-column justify-content-center text-start flex-grow-1">
      <p class="mb-1 text-xs text-white">{{ card.title }}</p>
      <p class="m-0 fw-bold text-white">{{ card.count }}</p>
    </div>
  </div>
</div>

    </div>
  </div>

  <div v-if="is_loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2">Loading leads...</p>
  </div>

  <div v-show="selected_status && !is_loading" class="card rounded-lg p-0 mt-3 shadow">
    <div class="card-header bg-white border-0 d-flex justify-content-between align-items-center pb-0 rounded-lg">
      <p class="mb-0">
        {{ status_cards.find(card => card.type === selected_status)?.title || 'Leads' }}
      </p>
    </div>
    <div class="card-body p-3">
      <div class="d-flex align-items-center mb-3">
        <div class="ms-auto">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            data-bs-toggle="modal"
            data-bs-target="#add_lead_modal"
            @click="reset_lead_form"
          >
            Add Lead
          </button>
        </div>
      </div>
      <div class="table-responsive text-xs">
        <table id="leads_table" class="table table-hover">
          <thead class="custom-header">
            <tr>
              <th v-for="header in table_headers" :key="header" class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">
                {{ header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="lead in filtered_leads" :key="lead.id">
              <td class="text-xxs text-start">{{ lead['Lead ID'] }}</td>
              <td class="text-xxs text-start">{{ lead.Name }}</td>
              <td class="text-xxs text-start">{{ lead.Email }}</td>
              <td class="text-xxs text-start">{{ lead.Phone }}</td>
              <td class="text-xxs text-start">{{ lead['Date Created'] }}</td>
              <td class="text-xxs text-start">
                <span class="text-xxs" :class="{
                  'text-dark': lead.Status === 'in-progress',
                  'bg-success': lead.Status === 'submitted',
                  'bg-danger': lead.Status === 'awaiting-verification',
                  'bg-info': lead.Status === 'approved',
                  'bg-secondary': lead.Status === 'closed'
                }">
                  {{ lead.Status }}
                </span>
              </td>
              <td class="text-xxs text-start">
                <div class="d-flex align-items-center gap-2">
                  <router-link
                    :to="{ name: 'leads_responses', query: { lead_id: lead['Lead ID'] } }"
                    class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                  >
                    View
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <AICampusFooter />
</div>
<teleport to="body">
  <div
    class="modal fade"
    id="add_lead_modal"
    tabindex="-1"
    aria-labelledby="add_lead_modal_label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">

        <!-- Header -->
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <h5 class="modal-title text-white text-xxs" id="add_lead_modal_label">
            Add Lead
          </h5>
          <button
            type="button"
            class="modal-btn-close btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <!-- Body -->
        <div class="modal-body px-4 py-4">
          <div class="mb-0">
            <h6 class="mb-3 text-xxs fw-bold text-muted">Lead Details</h6>

            <div class="d-flex flex-column gap-3">
              <div v-for="question_wrap in enquiry_form_questions" :key="question_wrap.id">
                <!-- Question label -->
                <label class="form-label text-xxs mb-1">
                  {{ question_wrap.question?.question_text }}
                </label>

                <!-- short_text -->
                <input
                  v-if="question_wrap.question?.question_type === 'short_text'"
                  class="form-control form-control-sm text-xxs rounded-3 shadow-sm"
                  v-model="lead_form_dynamic[question_wrap.id]"
                  type="text"
                  :placeholder="`Enter ${question_wrap.question?.question_text?.toLowerCase() || 'value'}`"
                />

                <!-- multi_select inline checkboxes -->
                <div v-else-if="question_wrap.question?.question_type === 'multi_select'">
                  <div class="d-flex flex-wrap gap-3">
                    <div
                      v-for="(choice, choice_index) in (question_wrap.question?.choices || [])"
                      :key="`${question_wrap.id}-${choice_index}`"
                      class="form-check d-inline-flex align-items-center gap-2 m-0"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="`q-${question_wrap.id}-c-${choice_index}`"
                        :value="choice"
                        v-model="lead_form_dynamic[question_wrap.id]"
                      />
                      <label
                        class="form-check-label text-xxs mb-0"
                        :for="`q-${question_wrap.id}-c-${choice_index}`"
                      >
                        {{ choice }}
                      </label>
                    </div>
                  </div>
                </div>
                <!-- single_select -->
                <select
                  v-else-if="question_wrap.question?.question_type === 'single_select'"
                  class="form-select form-select-sm text-xxs rounded-3 shadow-sm"
                  v-model="lead_form_dynamic[question_wrap.id]"
                >
                  <option value="" disabled>Select an option</option>
                  <option
                    v-for="(choice, choice_index) in (question_wrap.question?.choices || [])"
                    :key="`${question_wrap.id}-${choice_index}`"
                    :value="choice"
                  >
                    {{ choice }}
                  </option>
                </select>
                <!-- fallback -->
                <input
                  v-else
                  type="text"
                  class="form-control form-control-sm text-xxs rounded-3 shadow-sm"
                  v-model="lead_form_dynamic[question_wrap.id]"
                  placeholder="Enter value"
                />

              </div>
            </div>


            <!-- Error -->
            <div
              v-if="lead_form_error"
              class="alert alert-danger py-2 px-3 mt-3 mb-0 text-xxs"
            >
              {{ lead_form_error }}
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer justify-content-end px-4 pb-3">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            @click="create_lead"
          >
            Save Lead
          </button>
        </div>

      </div>
    </div>
  </div>
</teleport>

